// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 892) return "static/chunks/892-d0fabcbda96c87d9.js";
	if (chunkId === 398) return "static/chunks/398-24d480aeaca41d6f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"242":"fddff9e66e958c8c","329":"20aa5808bb4d0818","349":"d52c66ec8490fc1d","733":"4cac72468a6e6655","931":"b905cc5a3e673c90"}[chunkId] + ".js";
};